import { RunContextApp }        from "framework/RCApp"
import { combineReducers }      from "redux"
import { sessionReducer } from "./SessionReducer"
import { evLoadReducer } from "./EVLoadReducer"

export const allReducers = (rc : RunContextApp) => combineReducers({
  session : sessionReducer(rc),
  evLoad : evLoadReducer(rc),
})